<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}} Grupo Taric FR EX</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header">
                    </div>

                    <div class="card-body-detalle">

                        <div class="group-filtros">

                            <div class="row">

                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="inpNombreGrupoTaric">Nombre Grupo Taric FR</label>
                                    <input formControlName="Descripcion" name="Descripcion" maxlength="200" title="" [ngClass]="displayFieldCss('Descripcion')"
                                           class="form-control" id="inpNombreGrupoTaric" type="text" value="">

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Descripcion','required')">
                                        Nombre de Grupo Taric FR es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="inpDescripcion">Código Taric</label>
                                    <input formControlName="CodigoTaric" numbersOnly name="CodigoTaric" title="" [ngClass]="displayFieldCss('CodigoTaric')"
                                           class="form-control" id="inpNombre" type="text" value="" maxlength="10"><!--maxlength="10"-->

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','required')">
                                        Código Taric es obligatorio
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','CodigoTaricMin4')">
                                        La cadena debe estar compuesta por una secuencia de entre 4 y 10 dígitos y que el total de dígitos sea par
                                    </div>

                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoTaric','taricpais_duplicated')">
                                        El Código Taric ya existe para el grupo de países FR
                                    </div>
                                </div>
                            </div>

                            <div class="row">

                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="intEstado">Grupo Países FR</label>
                                    <ng-select [items]="listGruposPaisesFr"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdGrupoPaisFr"
                                               loadingText="Cargando..."
                                               [readonly]="!listGruposPaisesFr || listGruposPaisesFr.length === 0"
                                               [loading]="!listGruposPaisesFr || listGruposPaisesFr.length === 0"
                                               notFoundText="Grupo Países Fr no encontrado"
                                               placeholder="-- Seleccione un Grupo Países Fr --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdGrupoPaisFr')">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>
                                    </ng-select>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdGrupoPaisFr','required')">
                                        Grupo Países FR es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpDescripcion">Porcentaje</label>
                                    <input formControlName="Porcentaje" numbersOnly name="Porcentaje" title="" [ngClass]="displayFieldCss('Porcentaje')"
                                           class="form-control" id="inpNombre" type="text" value="" maxlength="3"><!--maxlength="10"-->

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Porcentaje','required')">
                                        Porcentaje es obligatorio
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Porcentaje','max')">
                                        El Porcentaje debe ser menor de 100
                                    </div>

                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Porcentaje','maxlength')">
                                        El Porcentaje debe tener máximo 3 dígitos
                                    </div>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpActivo">Activo</label>
                                    <p-toggleButton class="form-control-togglebutton" formControlName="Activo"
                                                    onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                    offIcon="pi pi-times"></p-toggleButton>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</form>
